export default __webpack_public_path__ + "15826467429b2f8b0a594b72338d5727.svg";